// extracted by mini-css-extract-plugin
export var tags = "style-module--tags--7aca3";
export var title = "style-module--title--27dca";
export var video = "style-module--video--28e3f";